import gql from 'graphql-tag';
const A_WORDS_WPM_ACTIVITY_FRAGMENT = gql `
  fragment AWordsWpmActivityFragment on AWordsWpmActivity {
    targetKey
    rounds {
      words
    }
  }
`;
export default A_WORDS_WPM_ACTIVITY_FRAGMENT;
